import { useMatch, useLocation, PathPattern } from 'react-router-dom';

interface UseRouteMatchOptions extends PathPattern {
	path: string;
}

interface MatchResult extends ReturnType<typeof useMatch> {
	isExact: boolean;
}

function useRouteMatch(options: UseRouteMatchOptions): MatchResult | null {
	const match = useMatch(options);
	const location = useLocation();

	if (!match) {
		return null;
	}

	const isExact = match.pathname === location.pathname;

	return { ...match, isExact };
}

export { useRouteMatch };
